import React from 'react'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'

const TestimonialBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`testimonial-block ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <div className="testimonial-block-content">
          <div className="row">
            <div className="testimonial-block-image">
              <Image image={block.image} alt={block.alt} title={block.alt} />
            </div>
            <div className="testimonial-block-text">
              <p>"{block.text}"</p>
              <p className="testimonial-author">{block.author}</p>
              <p className="testimonial-author-description">
                {block.author_description}
              </p>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TestimonialBlock
